export function DateMonth(billDate) {
  let day = billDate.charAt(0) + billDate.charAt(1);
  let year = billDate.charAt(6) + billDate.charAt(7);
  let month = billDate.charAt(3) + billDate.charAt(4);
  let newMonth = '';
  if (month === '01') newMonth = 'ינואר';
  else if (month === '02') newMonth = 'פברואר';
  else if (month === '03') newMonth = 'מרץ';
  else if (month === '04') newMonth = 'אפריל';
  else if (month === '05') newMonth = 'מאי';
  else if (month === '06') newMonth = 'יוני';
  else if (month === '07') newMonth = 'יולי';
  else if (month === '08') newMonth = 'אוגוסט';
  else if (month === '09') newMonth = 'ספטמבר';
  else if (month === '10') newMonth = 'אוקטובר';
  else if (month === '11') newMonth = 'נובמבר';
  else if (month === '12') newMonth = 'דצמבר';
  let date = newMonth + ' ' + year;
  return date;
};
